import { Tooltip, Box } from '@mui/material';
import { RedCamera } from '@/features/video/components/icons/RedCamera';
import { GreenCamera } from '@/features/video/components/icons/GreenCamera';

export const cameraSize = 18;
export const activeScale = 1.2; // This will make the active icon 50% larger

interface CameraIconProps {
  camera: {
    name: string;
    angle: number;
  };
  xVal?: number;
  yVal?: number;
  theme: {
    palette: {
      error: {
        main: string;
      };
    };
  };
  isActive: boolean;
  onClick: () => void;
  isFlipped?: boolean;
  enabled?: boolean;
  /** Stack above a layer covering the surface (aiming a preset target). */
  raised?: boolean;
}

export const CameraIcon = ({
  camera,
  xVal,
  yVal,
  isActive,
  onClick,
  enabled,
  raised,
}: CameraIconProps) => {
  const cameraAngle = camera.angle;

  return (
    <Tooltip title={(camera as any).displayName || camera.name} arrow>
      <Box
        onClick={enabled ? onClick : undefined}
        sx={{
          position: 'absolute',
          left: xVal || 0,
          bottom: yVal || 0,
          transform: `rotate(${-cameraAngle}deg) scale(${isActive ? activeScale : 1})`,
          width: cameraSize,
          height: cameraSize,
          cursor: enabled ? 'pointer' : 'default',
          opacity: enabled ? 1 : 0,
          transition: 'all 0.3s ease',
          transformOrigin: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...(raised && { zIndex: 10002 }),
        }}
      >
        {isActive ? <RedCamera /> : <GreenCamera />}
      </Box>
    </Tooltip>
  );
};
